export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8348.a90024fe.jpg";